import React, { Fragment } from 'react'
import { FormDisplayErrors } from '@myxplor/forms'
import { Note } from '@myxplor/ui'
import { hasNestedErrors } from '../../../io/error-handling'
import { hintText } from './helpers'
import './gov-actions.css'

const GovActionErrorsWrapper = ({ errors }) => (
  <Fragment>
    <Note important>Your request resulted in some errors</Note>

    <div className="govActionErrors">
      <GovActionErrors errors={errors} />
    </div>
  </Fragment>
)

const GovActionErrors = ({ errors, baseName = '' }) =>
  Object.keys(errors).map((name, i) => (
    <GovActionError key={i} name={baseName + ' ' + name} errors={errors[name]} />
  ))

const GovActionError = ({ name, errors }) =>
  hasNestedErrors(errors) ? (
    <GovActionErrors errors={errors} baseName={name} />
  ) : (
    <FormDisplayErrors errors={hintText(errors, name)} />
  )

export default GovActionErrorsWrapper



// WEBPACK FOOTER //
// ./src/ui/forms/form-from-errors/errors.js